import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSignOut } from "@fortawesome/free-solid-svg-icons";

const LogoutIcon = ({ onLogout }) => {
  return (
    <div
      className="flex gap-2 text-red-500 hover:text-red-700 cursor-pointer"
      onClick={onLogout}
    >
      {" "}
      <li>
        <FontAwesomeIcon icon={faSignOut} size="lg" />
      </li>{" "}
      Logout
    </div>
  );
};

export default LogoutIcon;
